import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startCheckout = async (lookupKey, memberId) => {
    const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: lookupKey,
        origin_url: window.location.origin,
        member_id: memberId,
    });
    window.location.href = data.checkout_url;
};
